<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
      <div class="input-wrapper">
          <div class="side-wrapper edit-form-title-wrapper">
              <div class="user-icon"></div>
              <p class="input-form-title">{{'NAVIGATION_NODE_RULE.FORM_TITLE' | translate}}</p>
          </div>
  
          <div class="menu-input-wrapper">
              <div class="tab-menu">
                  <div class="tab basic-info" (click)="setActiveTab('basic-info')" [ngClass]="{'active': activetab=='basic-info'}">
                      <p>{{'HOME.ROLES_BASICINFO_TABTITLE' | translate}}</p>
                  </div>
                  <div class="tab roles" (click)="setActiveTab('roles')" [ngClass]="{'active': activetab=='roles'}">
                    <p>{{'HOME.USERS_ROLES_TABTITLE' | translate}}</p>
                 </div>
              </div>
              <!--
              -->
              <div class="input-content">
                  <div class="basic-info" *ngIf="activetab == 'basic-info'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                            <div class="input-control">
                                <div class="title"><label for="Title">{{'NAVIGATION_NODE.TITLE' | translate}}</label></div>
                                <input class="form-control" type="text" name="Title" [(ngModel)]="model.Title" required/>
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="Order">{{'NAVIGATION_NODE.ORDER' | translate}}</label></div>
                                <input class="form-control" type="number" name="Order" [(ngModel)]="model.Order" required/>
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="ParentId">{{'NAVIGATION_NODE.PARENT' | translate}}</label></div>
                                <input class="form-control" type="text" name="ParentId" [(ngModel)]="model.ParentId" />
                            </div>  
                            <div class="input-control">
                                <div class="title"><label for="ContextName">{{'NAVIGATION_NODE.CONTEXT_NAME' | translate}}</label></div>
                                <select class="form-control" name="ContextName" [(ngModel)]="model.ContextName" required>
                                    <option value="left-menu">Left menu</option>
                                    <option value="top-form-action">Top form action</option>
                                    <option value="top-list-action">Top list action</option>
                                </select>
                            </div>                           
                            <div class="input-control">
                                <div class="title"><label for="Icon">{{'NAVIGATION_NODE.ICON' | translate}}</label></div>
                                <input class="form-control" type="text" name="Icon" [(ngModel)]="model.Icon" />
                            </div>                            
                            <div class="input-control">
                                <div class="title"><label for="TooltipText">{{'NAVIGATION_NODE.TOOLTIP_TEXT' | translate}}</label></div>
                                <input class="form-control" type="text" name="TooltipText" [(ngModel)]="model.TooltipText" />
                            </div>                                  
                            <div class="input-control">
                                <div class="title"><label for="Url">{{'NAVIGATION_NODE.URL' | translate}}</label></div>
                                <input class="form-control" type="text" name="Url" [(ngModel)]="model.Url"/>
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="Type">{{'NAVIGATION_NODE.TYPE' | translate}}</label></div>
                                <input class="form-control" type="number" name="Type" [(ngModel)]="model.Type" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="NavigationNodeRuleId">{{'NAVIGATION_NODE.RULE' | translate}}</label></div>
                                <!--<input class="form-control" type="number" name="NavigationNodeRuleId" [(ngModel)]="model.NavigationNodeRuleId" />-->

                                <select name="NavigationNodeRuleId" [(ngModel)]="model.NavigationNodeRuleId">
                                    <option *ngFor="let r of rules.Items" [value]="r.Id">{{r.Id}} - {{r.Condition}}</option>
                                </select>

                            </div>                            
                            <div class="input-control">
                                <div class="title"><label for="Provider">{{'NAVIGATION_NODE.PROVIDER' | translate}}</label></div>
                                <input class="form-control" type="text" name="Provider" [(ngModel)]="model.Provider" />
                            </div>                            
                            <div class="input-control">
                                <div class="title"><label for="Parameters">{{'NAVIGATION_NODE.PARAMETERS' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="Parameters" [(ngModel)]="model.Parameters"></textarea>
                            </div> 

                            <div class="input-control">
                                <div class="title"><label for="BulkAction">{{'NAVIGATION_NODE.BULK_ACTION' | translate}}</label></div>
                                <input type="checkbox" name="BulkAction" [(ngModel)]="model.BulkAction"/>
                            </div> 
                            <div class="input-control">
                                <div class="title"><label for="BulkExport">{{'NAVIGATION_NODE.BULK_EXPORT' | translate}}</label></div>
                                <input type="checkbox" name="BulkExport" [(ngModel)]="model.BulkExport"/>
                            </div> 
                            <div class="input-control">
                                <div class="title"><label for="IsOnlyParent">{{'NAVIGATION_NODE.ONLY_PARENT' | translate}}</label></div>
                                <input type="checkbox" name="IsOnlyParent" [(ngModel)]="model.IsOnlyParent"/>
                            </div> 

                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
                              </div>
                          </div>
                      </div>
                  </div> 
                  <div class="roles" *ngIf="activetab == 'roles'">
                    <div class="section-wrapper">
                        <p class="section-title">{{'HOME.USERS_ROLES_TABTITLE' | translate}}</p>
                    </div>

                    <div class="side-combiner">
                        <div class="side-input-container">
                            <div class="input-control">  
                                <div class="checkbox" *ngFor="let ug of model.GroupsModel.Groups">
                                    <label>
                                        <input  type="checkbox" [(ngModel)]="ug.Selected" [ngModelOptions]="{standalone: true}"/>
                                        <span class="checkmark"></span>
                                        {{ug.Name}}
                                    </label>
                                </div>       
                            </div>
                        </div>
                        <!--
                            -->
                        <div class="side-input-container">
                        </div>
                    </div>
                </div>
              </div>
          </div>
  
      </div>
  </form>
  </div>

